export default "__VITE_ASSET__YtZsS1Bw__"